import crypto from "crypto";

export const isValidObjectId = (value?: string | null): value is string =>
  Boolean(
    value &&
      value !== "undefined" &&
      value !== "null" &&
      /^[a-f\d]{24}$/i.test(value)
  );

export const sanitizeOptionalId = (value?: string | null): string | undefined =>
  isValidObjectId(value) ? value : undefined;

export const sanitizeString = (value?: string | null): string | undefined => {
  if (!value || value === "undefined" || value === "null") return undefined;
  return value;
};

/** Dynamic signup forms may omit password; OTP flow sets it later. */
export const resolveSignupPassword = (password?: string | null): string => {
  const sanitized = sanitizeString(password);
  if (sanitized && sanitized.length >= 8) return sanitized;
  return crypto.randomBytes(32).toString("hex");
};
